import { COLD_WEATHER_BATTERY_VERSION } from '~/devices/device-helpers';
import '../../common/bn-flash';
import '../../common/bn-loading';
import '../../common/qr-scanner';
import '../../devices/props/device-serial-number';
import '../../devices/props/device-firmware-mode';
import '../../devices/props/device-time-since-last-event';
import { sharedStyles } from '../../styles/shared-styles';
import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, SirenActionMixin, html, css, renderIf } from '../../utility/lit-entity';

class WorkOrderDeviceBattery extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      deviceHref: { type: String, attribute: false },
      deviceEntity: { type: Object, attribute: false },
      hasColdWeatherBattery: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .required {
        color: red;
      }
      bn-property {
        display: flex;
        align-items: center;
      }
    `];
  }

  renderEntity() {
    const currentBatteryVersion = this.deviceEntity?.properties.batteryVersion;
    const isBatteryUpgrade = this.entity.properties.preDiagnosis === 'Battery Upgrade';
    return html`
      <lit-entity .href="${this.deviceHref}" @update="${this._onUpdateDevice}"></lit-entity>
      <div>
        <span>
          <bn-property label="Current Device Battery">
            <device-battery-display-name .href="${this.deviceHref}"></device-battery-display-name>
            ${renderIf(currentBatteryVersion && this.entity.hasAction('update-device-battery'), () => html`
              <button
                @click="${() => this.updateDeviceBattery()}"
                class="button button--text"
              >Undo</button>
            `)}
          </bn-property>
        </span>
        ${renderIf(!currentBatteryVersion && this.entity.hasAction('update-device-battery'), () => html`
          <div>
            Did you install a new Cold Weather battery?
            ${renderIf(isBatteryUpgrade, () => html`<span class="required">*</span>`)}
            </div>
          <div class="action">
            <button 
              class="button button--contained"
              @click="${() => this.updateDeviceBattery(COLD_WEATHER_BATTERY_VERSION)}"
            >New Battery Installed</button>
          </div>
        `)}
      </div>
    `;
  }

  async updateDeviceBattery(batteryVersion) {
    const updateVersionsAction = this.entity.getAction('update-device-battery');
    if (updateVersionsAction) {
      updateVersionsAction.getFieldByName('batteryVersion').value = batteryVersion;
      await this.submitAction(updateVersionsAction);
      entityStore.invalidateHref(this.href);
      entityStore.invalidateHref(this.deviceHref);
    }
  }

  _onUpdateDevice(e) {
    const { entity } = e.detail;
    this.deviceEntity = entity;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    const deviceHref = this.entity && this.entity.getSubEntityByClasses(['device', 'active']).href;
    this.hasColdWeatherBattery = this.entity?.properties.preDiagnosis === 'Battery Upgrade';
    if (deviceHref) {
      this.deviceHref = deviceHref;
    }
  }
}

window.customElements.define('work-order-device-battery', WorkOrderDeviceBattery);
